import InView from './inviewAnimate';

const verticalLine = {
    customClass: 'draw-line',
    customItem: '.vertical-line',
};

const drawLine = new InView(verticalLine);

export default drawLine;
